module.exports = __webpack_public_path__ + "images/receipt-bg.png";